const removeNullFromObject = (object) => {
    let data = {};
    for (let key in object) {
        if (object[key]) {
            data = { ...data, [key]: object[key] }
        }
    }
    return data;
}
export { removeNullFromObject };